// src/components/modals/CreateStoreModal.jsx
import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';

const CreateStoreModal = ({ isOpen, onClose, onSubmit, marcas }) => {
    const [formData, setFormData] = useState({
        via: '',
        calle: '',
        numero: '',
        poblacion: '',
        pais: '',
        region: '',
        nombre: '',
        descripcion: '',
        marca: marcas && marcas.length > 0 ? marcas[0]._id : '',
    });

    // Efecto para controlar el scroll del body
    useEffect(() => {
        if (isOpen) {
            // Guarda la posición actual del scroll
            const scrollY = window.scrollY;
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';
        } else {
            // Restaura la posición del scroll
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
        }

        return () => {
            // Limpieza al desmontar
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        // Validaciones básicas
        if (!formData.nombre || !formData.descripcion) {
            Swal.fire('Error', 'Por favor, complete los campos requeridos.', 'error');
            return;
        }
        onSubmit(formData);
    };

    return (
        <div className="fixed z-50 inset-0 bg-gray-500 bg-opacity-75">
            {/* Container principal - Ocupa toda la pantalla en móvil */}
            <div className="h-full md:py-8">
                {/* Modal */}
                <div className="h-full md:h-auto md:max-h-[90vh] w-full md:max-w-2xl mx-auto bg-white md:rounded-lg md:shadow-xl flex flex-col">
                    {/* Header */}
                    <div className="flex-shrink-0 px-4 py-3 border-b border-gray-200 bg-white">
                        <div className="flex items-center justify-between">
                            <h3 className="text-lg font-medium text-gray-900 flex items-center gap-2">
                                <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                </svg>
                                Crear Nueva Tienda
                            </h3>
                            <button
                                onClick={onClose}
                                className="text-gray-400 hover:text-gray-500 p-1"
                            >
                                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                    </div>

                    {/* Formulario */}
                    <form onSubmit={handleFormSubmit} className="flex-1 flex flex-col min-h-0">
                        {/* Contenido Scrolleable */}
                        <div className="flex-1 overflow-y-auto">
                            <div className="px-4 py-4 space-y-6">
                                {/* Información Básica */}
                                <section>
                                    <h4 className="text-sm font-medium text-gray-700 mb-3">
                                        Información Básica
                                    </h4>
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Nombre de la Tienda*
                                            </label>
                                            <input
                                                type="text"
                                                name="nombre"
                                                value={formData.nombre}
                                                onChange={handleChange}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                                placeholder="Ej. Tienda Centro"
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Descripción*
                                            </label>
                                            <textarea
                                                name="descripcion"
                                                value={formData.descripcion}
                                                onChange={handleChange}
                                                rows="2"
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent resize-none"
                                                placeholder="Describe brevemente tu tienda"
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Marca*
                                            </label>
                                            <select
                                                name="marca"
                                                value={formData.marca}
                                                onChange={handleChange}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                                required
                                            >
                                                <option value="" disabled>Selecciona una marca</option>
                                                {marcas.map((marca) => (
                                                    <option key={marca._id} value={marca._id}>
                                                        {marca.nombre}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </section>

                                {/* Dirección */}
                                <section>
                                    <h4 className="text-sm font-medium text-gray-700 mb-3">
                                        Dirección
                                    </h4>
                                    <div className="grid grid-cols-2 gap-4">
                                        <div className="col-span-2 sm:col-span-1">
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Tipo de Vía*
                                            </label>
                                            <input
                                                type="text"
                                                name="via"
                                                value={formData.via}
                                                onChange={handleChange}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                                placeholder="Ej. Calle"
                                                required
                                            />
                                        </div>

                                        <div className="col-span-2 sm:col-span-1">
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Nombre de la Vía*
                                            </label>
                                            <input
                                                type="text"
                                                name="calle"
                                                value={formData.calle}
                                                onChange={handleChange}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                                placeholder="Ej. Gran Vía"
                                                required
                                            />
                                        </div>

                                        <div className="col-span-1">
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Número*
                                            </label>
                                            <input
                                                type="text"
                                                name="numero"
                                                value={formData.numero}
                                                onChange={handleChange}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                                placeholder="123"
                                                required
                                            />
                                        </div>

                                        <div className="col-span-1">
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                País*
                                            </label>
                                            <select
                                                name="pais"
                                                value={formData.pais}
                                                onChange={handleChange}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                                required
                                            >
                                                <option value="" disabled>País</option>
                                                <option value="España">España</option>
                                                <option value="Chile">Chile</option>
                                                <option value="Peru">Perú</option>
                                            </select>
                                        </div>

                                        <div className="col-span-1">
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Región*
                                            </label>
                                            <input
                                                type="text"
                                                name="region"
                                                value={formData.region}
                                                onChange={handleChange}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                                placeholder="Región"
                                                required
                                            />
                                        </div>

                                        <div className="col-span-1">
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Ciudad*
                                            </label>
                                            <input
                                                type="text"
                                                name="poblacion"
                                                value={formData.poblacion}
                                                onChange={handleChange}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                                placeholder="Ciudad"
                                                required
                                            />
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>

                        {/* Footer con botones */}
                        <div className="flex-shrink-0 px-4 py-3 border-t border-gray-200 bg-white">
                            <div className="flex justify-end gap-3">
                                <button
                                    type="button"
                                    onClick={onClose}
                                    className="px-3 py-1.5 text-sm text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md"
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="submit"
                                    className="px-3 py-1.5 text-sm text-white bg-green-600 hover:bg-green-700 rounded-md flex items-center gap-1"
                                >
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                    </svg>
                                    Crear Tienda
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CreateStoreModal;
